import TableLayout from "../../layout/main/TableLayout";
import { Column, DText, Flex, Relative, Row } from "../../../styles/CommonStyles";
import { formatName } from "../../../core/utils/common";
import { DocumentStatus, UserStatus } from "../../../styles/main/profile";
import Text from "../../../core/utils/Text";
import Operation from "../../common/utils/Operation";
import Avatar from "../../common/utils/Avatar";
import useUsersList from "../../../core/hooks/main/users/useUsersList";
import useGetTableIndex from "../../../core/hooks/layout/useGetTableIndex";
import { userAttributes } from "../../../core/constants/headers";

const UsersTable = ({ data }) => {

    const { data: users } = data
    const { cs, headers } = userAttributes
    const { getTableIndex } = useGetTableIndex()

    const {
        hasWriteAccess,
        onOptionClicked,
        onDetailsClicked
    } = useUsersList()

    return (
        <TableLayout
            headers={headers}
            cs={cs}
            data={data}
            hasWriteAccess={hasWriteAccess}
        >
            {users?.data?.map((user, idx) => {

                const EMAIL_VERIFIED = !!user.email_verified_at
                const MOBILE_VERIFIED = !!user.mobile_verified_at

                return (
                    <Relative key={user.id}>
                        <Row cs={cs} index={idx}>

                            <Column>
                                {getTableIndex(idx)}
                            </Column>

                            <Column avatar>
                                <Flex width='42px'>
                                    <Avatar
                                        name={user.name}
                                        avatar={null}
                                    />
                                </Flex>

                                <DText fontSize={'s'} main>
                                    {formatName(user.name || '--')}
                                </DText>
                            </Column>

                            <Column>
                                {user.referral_code || '--'}
                            </Column>

                            <Column>
                                {user.mobile || '--'}
                            </Column>

                            <Column>
                                {user.email || '--'}
                            </Column>


                            <Column>
                                <UserStatus active={EMAIL_VERIFIED}>
                                    <Text tid={EMAIL_VERIFIED ? 'verified' : 'not-verified'} />
                                </UserStatus>
                            </Column>

                            <Column>
                                <DocumentStatus active={MOBILE_VERIFIED}>
                                    <Text tid={MOBILE_VERIFIED ? 'verified' : 'not-verified'} />
                                </DocumentStatus>
                            </Column>

                            <Column>
                                {user.created_at || '--'}
                            </Column>

                        </Row>
                        <Column operation>
                            <Operation
                                // options={user.verifyAt ? rejectUserOperations : acceptUserOperations}
                                onOptionClicked={(idx) => onOptionClicked(idx, user)}
                                onDetailsClicked={() => onDetailsClicked(user)}
                                hasWriteAccess={hasWriteAccess}
                                hasDetails
                            />
                        </Column>
                    </Relative>

                )
            })}
        </TableLayout>
    )
}

export default UsersTable